module.exports = __webpack_public_path__ + "img/f.2742c71d.jpg";